/* Keep approved editorial covers until a shopper selects a native Shopify swatch. */
(() => {
  'use strict';
  const defaults = new WeakMap();
  const requests = new WeakMap();
  const attributes = ['src', 'srcset', 'sizes', 'alt', 'width', 'height'];
  const restore = (image) => {
    const saved = defaults.get(image);
    if (!saved) return;
    for (const name of attributes) {
      const value = saved[name];
      if (value === null) image.removeAttribute(name);
      else image.setAttribute(name, value);
    }
  };

  document.addEventListener('shopify:product:select', (event) => {
    if (!(event.target instanceof Element)) return;
    const picker = event.target.closest('swatches-variant-picker-component');
    const card = picker?.closest('product-card');
    if (!card || !card.closest('.dya-product-edit')) return;
    const image = card.querySelector('.dya-curated-cover__image');
    const metadata = card.querySelector('.dya-card-variant-images');
    if (!image || !metadata) return;
    const productId = String(event.product?.id ?? '').split('/').pop();
    if (productId && productId !== card.dataset.productId) return;
    if (!defaults.has(image)) {
      defaults.set(image, Object.fromEntries(attributes.map(name => [name, image.getAttribute(name)])));
    }
    let variants;
    try { variants = JSON.parse(metadata.textContent || '{}'); }
    catch { return; }
    const token = {};
    requests.set(card, token);
    const current = () => requests.get(card) === token && card.isConnected && image.isConnected;

    Promise.resolve(event.promise).then(async (selection) => {
      if (!current()) return;
      const variantId = selection?.variant?.id ?? event.detail?.variantId;
      const selected = variants[String(variantId ?? '').split('/').pop()];
      if (!selected?.src) { restore(image); return; }
      const url = new URL(selected.src, document.baseURI);
      if (!['https:', 'http:'].includes(url.protocol)) { restore(image); return; }
      const next = new Image();
      next.src = url.href;
      try {
        await next.decode();
      } catch {
        if (current()) restore(image);
        return;
      }
      if (!current()) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = url.href;
      image.alt = typeof selected.alt === 'string' ? selected.alt : defaults.get(image).alt || '';
      if (Number.isFinite(selected.width) && selected.width > 0) image.width = selected.width;
      if (Number.isFinite(selected.height) && selected.height > 0) image.height = selected.height;
    }).catch(() => {
      // Native picker handles failed/aborted requests. Keep the last valid photo.
    });
  }, true);
})();
